function notInitialized() {
  throw new Error('Cookie jar is not initialized');
}

export default {
  get: notInitialized,
};
